const hasNonEmptyValue = (value) => {
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'string') return value.trim().length > 0;
  if (value && typeof value === 'object') return Object.keys(value).length > 0;
  return Boolean(value);
};

export const countSelectedPanels = (selectedPanels = {}) => {
  if (!selectedPanels || typeof selectedPanels !== 'object') return 0;

  return Object.values(selectedPanels).reduce(
    (sum, roofPanels) =>
      sum +
      (Array.isArray(roofPanels)
        ? roofPanels.reduce(
          (roofSum, value) => roofSum + (Number(value) > 0 ? 1 : 0),
          0
        )
        : 0),
    0
  );
};

export const getProductionReadiness = ({
  solarProduction = 0,
  totalPanels = 0,
  stringingData = null,
  invertersUsed = null,
  isLegacyProposal = false,
} = {}) => {
  const hasAnnualProduction = Number(solarProduction || 0) > 0;
  const hasPanelCount = Number(totalPanels || 0) > 0;
  const hasStringingData = hasNonEmptyValue(stringingData);
  const hasInvertersUsed = hasNonEmptyValue(invertersUsed);
  const hasLegacyProductionIndicator =
    hasPanelCount || hasStringingData || hasInvertersUsed;
  const hasCompleteModernTopology =
    hasPanelCount && hasStringingData && hasInvertersUsed;

  return {
    hasAnnualProduction,
    hasPanelCount,
    hasStringingData,
    hasInvertersUsed,
    hasPersistedProduction:
      hasAnnualProduction &&
      (isLegacyProposal
        ? hasLegacyProductionIndicator
        : hasCompleteModernTopology),
    hasSolarProductionOnly:
      isLegacyProposal && hasAnnualProduction && !hasLegacyProductionIndicator,
    shouldRecalculateModernProduction:
      !isLegacyProposal && hasAnnualProduction && !hasCompleteModernTopology,
  };
};
